import { PaginationState } from '@tanstack/react-table';

export const isFetchFromBackend = (reportData: any | null, state: PaginationState) =>
	reportData?.getTotalRows &&
	reportData?.getData() &&
	reportData?.getTotalRows() > reportData?.getData()?.length &&
	state.pageIndex * state.pageSize >= reportData?.getData()?.length &&
	reportData?.getData()?.length !== 0;
